import { stubTrue } from 'lodash';

import { LineArea } from '@/charts';
import { getYValue } from '@/charts/helpers';
import { ColorIcon, LineIcon } from '@/components/data/ColorIcon';
import { DirectionDatum } from '@/components/data/DirectionDatum';
import { SpreadDatum } from '@/components/data/SpreadDatum';
import { DataDetailDatum } from '@/components/spotter/historicalDataTab/datumDetail/DataDetailPanel';

export type WaveDirectionDatumDetailProps<D extends { processing_source: string }> = {
    datum: D;
    line: LineArea<D>;
};

export const WaveDirectionDatumDetail = <D extends { processing_source: string }>({
    datum,
    line,
}: WaveDirectionDatumDetailProps<D>) => {
    const { label, valueKey, yAreaLabel, yAreaKeyName, color } = line;

    if (!(line.dataFilter ?? stubTrue)(datum) || !Number.isFinite(datum[valueKey as keyof D])) return false;

    return (
        <>
            <DataDetailDatum label={label} icon={<LineIcon dot color={color.line} />}>
                <DirectionDatum
                    iconSx={{ fontSize: '1em' }}
                    heading={getYValue(datum, valueKey)}
                    type="source"
                    unit="deg"
                />
            </DataDetailDatum>
            {yAreaKeyName in datum && (
                <DataDetailDatum label={yAreaLabel} icon={<ColorIcon color={color.area} />}>
                    <SpreadDatum spread={getYValue(datum, yAreaKeyName)} unit="deg" />
                </DataDetailDatum>
            )}
        </>
    );
};
